import React from 'react';
import { Play, Check } from 'lucide-react';
import { hw1, hw2, hw3, unq1, unq2, vectorMin } from '../assets/assets';

const HowItWorks = () => {
  // Content data
  const features = [
    {
      id: 1,
      icon: <Check size={20} className="text-gray-200" />,
      title: "Sign up quick and easy",
      description: "Create your account in minutes with a simple and secure process. No hassle, no delays—just instant access to top tech talent."
    },
    {
      id: 2,
      icon: <Check size={20} className="text-gray-300" />,
      title: "Pick from available services",
      description: "Explore a wide range of services tailored to your needs. From web development to UI/UX design and beyond, find exactly what fits your project."
    },
    {
      id: 3,
      icon: <Check size={20} className="text-[#174568]" />,
      title: "Get connected with our experts",
      description: "Start working with professionals right away. Communicate, share updates, and receive your completed project efficiently and stress-free."
    }
  ];

  return (
    <section className="bg-[#ACACAC1F] py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row-reverse md:gap-10">
          
          {/* Left side - Video/Images */}
          <div className='w-full md:w-1/2 md:pr-8 mb-6 md:mb-0 flex flex-col'>
          <a href="/tutorials" className="hidden md:flex items-center text-[#174568] font-medium ml-auto mb-10">
          Learn more <img src={vectorMin} className='ml-2'/>
        </a>
          <div className="">
       
            <div className="relative mb-3 md:mb-6 h-[322px]">
              <div className="rounded-xl md:rounded-2xl overflow-hidden h-full">
              <img
  className="w-full h-full"
  src={hw1}
  
/>
              </div>
           
            </div>
            <div className="flex gap-3 md:gap-4">
              <div className="w-1/2 rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src={hw2} 
                  alt="Developer working" 
                  className="w-full h-auto"
                />
              </div>
              <div className="w-1/2 rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src={hw3}
                  alt="Modern workspace" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
          </div>
          
          {/* Right side - Text content */}
          <div className="w-full md:w-1/2 md:pl-8">
          <div className="flex items-center items-between">
            <h2 className="text-xl md:text-3xl font-bold text-[#174568] mb-4 md:mb-10">HOW IT WORKS</h2>
            <a href="/tutorials" className="md:hidden flex items-center text-[#174568] font-medium ml-auto mb-10">
          Learn more <img src={vectorMin} className='ml-2'/>
        </a>
            </div>
            
            <div className="space-y-4 md:space-y-6">
              {features.map((feature, index) => (
                <div 
                  key={feature.id} 
                  className={`rounded-xl p-4 md:p-6 ${
                    index === 2 ? 'bg-[#4B718F]' : 'bg-gray-200 text-gray-800'
                  }`}
                >
                  <div className="flex items-start">
                    <div className={`rounded-full w-7 h-5 md:w-[20.66px] md:h-[20.66px] flex items-center justify-center mr-2 md:mr-3 ${
                      index === 2 ? 'bg-[#EDF2FE]' : 'bg-[#174568]'
                    }`}>
                      {React.cloneElement(feature.icon, { 
                        size: typeof window !== 'undefined' && window.innerWidth < 768 ? 16 : 20 
                      })}
                    </div>
                    <div>
                      <h3 className={`font-medium text-base md:text-lg mb-1 md:mb-2 ${index === 2 ? 'text-white' : 'text-[#174568]'}`}>{feature.title}</h3>
                      <p className={`text-xs md:text-sm ${index === 2 ? 'text-white' : 'text-black'}`}>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;